import { LiquidDialog } from './LiquidUI';
import React, { useState } from 'react';
import api from '../services/api';

/* Envio em lote dos avisos de abastecimento mal lançado.

   Vive na própria lista de Despesas e Movimentos — que é onde os movimentos
   caem e onde se percebe do que se está a falar —, e não num separador à parte.
   A escolha faz-se com a caixa antes do fornecedor; esta barra aparece assim
   que houver alguma escolhida.

   Sai UMA mensagem por pessoa, com as despesas dela todas dentro. Seis
   mensagens seguidas à mesma pessoa é a melhor maneira de nenhuma ser lida.
   ============================================================ */
const LoteMensagens = ({ escolhidas, onLimpar, onEnviado, tipo = 'despesas' }) => {
    /* Dois assuntos, o mesmo circuito: despesas de abastecimento mal lançadas e
       movimentos sem fatura. Muda o que se escolhe e a quem se pede — nas
       despesas avisa-se quem lançou, nos movimentos o titular do cartão, que é
       a única pessoa conhecida quando ninguém lançou nada. */
    const conf = tipo === 'movimentos'
        ? { preparar: '/combustivel/sem-fatura/lote', enviadas: '/combustivel/sem-fatura/lote/enviadas',
            campo: 'transacao_ids', rotulo: 'movimento(s)',
            nota: 'Sai uma mensagem por titular de cartão, com os movimentos dele todos.' }
        : { preparar: '/combustivel/avisos/lote', enviadas: '/combustivel/avisos/lote/enviadas',
            campo: 'despesa_ids', rotulo: 'despesa(s)',
            nota: 'Sai uma mensagem por colaborador, com as despesas dele todas dentro.' };
    const [lote, setLote] = useState(null);
    const [erro, setErro] = useState('');
    const [ocupado, setOcupado] = useState(false);
    if (!escolhidas.size && !lote) return null;

    const preparar = async () => {
        setOcupado(true); setErro('');
        try {
            const r = await api.post(conf.preparar, { [conf.campo]: [...escolhidas] });
            setLote(r.data || []);
        } catch (e) { setErro(e.response?.data?.error || e.message); }
        finally { setOcupado(false); }
    };

    /* Todas de uma vez. As janelas abrem-se em bloco e ainda dentro do clique —
       se ficassem para depois de um await o browser bloqueava-as todas menos a
       primeira.

       Mesmo assim o browser pode barrar as seguintes, e aí window.open devolve
       null. Só se regista quem abriu de facto: já aconteceu marcarem-se quatro
       colaboradores como avisados quando só a conversa do primeiro tinha
       aberto. Quem ficou de fora continua na lista, por enviar. */
    const enviar = async (grupos) => {
        setOcupado(true); setErro('');
        const abertas = [], barradas = [];
        for (const g of grupos.filter(g => g.numero)) {
            const janela = window.open(
                `https://wa.me/${g.numero}?text=${encodeURIComponent(g.texto)}`, '_blank');
            (janela ? abertas : barradas).push(g);
        }
        try {
            for (const g of abertas) {
                await api.post(conf.enviadas, { [conf.campo]: g[conf.campo], texto: g.texto, para: g.numero });
            }
            const ids = abertas.flatMap(g => g[conf.campo]);
            setLote(l => {
                const resta = l.filter(x => !abertas.includes(x));
                return resta.length ? resta : null;
            });
            if (barradas.length) {
                setErro(`O browser bloqueou ${barradas.length} janela(s): `
                    + barradas.map(g => g.quem || 'sem nome').join(', ')
                    + '. Autoriza as janelas para este site e volta a carregar em Enviar todas — '
                    + 'estes ficaram por avisar.');
            }
            if (ids.length) onEnviado && onEnviado(ids);
        } catch (e) { setErro(e.response?.data?.error || e.message); }
        finally { setOcupado(false); }
    };

    const botao = { padding: '5px 12px', fontSize: '0.8rem' };

    return (
        <>
            {escolhidas.size > 0 && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap',
                    background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 8,
                    padding: '8px 12px', margin: '0 0 10px' }}>
                    <strong style={{ fontSize: '0.85rem', color: '#1e40af' }}>
                        {escolhidas.size} {conf.rotulo} escolhido(s)
                    </strong>
                    <button className="btn-primary" style={botao} disabled={ocupado} onClick={preparar}>
                        💬 Preparar mensagens
                    </button>
                    <button className="btn-secondary" style={botao} onClick={onLimpar}>Limpar escolha</button>
                    <span style={{ fontSize: '0.78rem', color: '#475569' }}>
                        {conf.nota}
                    </span>
                    {erro && <span style={{ color: '#b91c1c', fontSize: '0.8rem' }}>{erro}</span>}
                </div>
            )}

            {lote && (
                <LiquidDialog onClose={() => setLote(null)} onClick={() => setLote(null)}
                    style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', zIndex: 2000,
                        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
                    <div data-liquid-surface="true" onClick={e => e.stopPropagation()}
                        style={{ background: '#fff', borderRadius: 12, padding: '20px 22px', width: 640,
                            maxWidth: '94vw', maxHeight: '86vh', overflowY: 'auto' }}>
                        <h3 style={{ margin: '0 0 12px', fontSize: '1.05rem' }}>
                            Mensagens a enviar ({lote.length} colaborador{lote.length === 1 ? '' : 'es'})
                        </h3>
                        {/* O aviso das janelas bloqueadas tem de se ver aqui: a barra da
                            escolha desaparece assim que os enviados saem da lista. */}
                        {erro && (
                            <p style={{ background: '#fef2f2', border: '1px solid #fecaca', color: '#b91c1c',
                                borderRadius: 8, padding: '8px 10px', fontSize: '0.8rem', margin: '0 0 12px' }}>{erro}</p>
                        )}
                        {lote.length === 0 && <p style={{ color: '#64748b' }}>Está tudo enviado.</p>}
                        {lote.map((g, i) => (
                            <div key={i} style={{ border: '1px solid #e2e8f0', borderRadius: 8, padding: 12, marginBottom: 10 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                                    <strong style={{ fontSize: '0.9rem' }}>{g.quem || 'Sem colaborador'}</strong>
                                    <span style={{ fontSize: '0.78rem', color: '#64748b' }}>
                                        {g[conf.campo].length} {conf.rotulo}{g.numero ? ` · +${g.numero}` : ''}
                                    </span>
                                </div>
                                {g.titular_cartao && (
                                    <p style={{ fontSize: '0.78rem', color: '#64748b', margin: '4px 0 0' }}>
                                        Foi quem lançou. O cartão está em nome de {g.titular_cartao}.
                                    </p>
                                )}
                                {g.aviso && <p style={{ color: '#b45309', fontSize: '0.8rem', margin: '6px 0 0' }}>⚠ {g.aviso}</p>}
                                <textarea value={g.texto} rows={7}
                                    onChange={e => setLote(l => l.map(x => x === g ? { ...x, texto: e.target.value } : x))}
                                    style={{ width: '100%', boxSizing: 'border-box', marginTop: 8, padding: 9,
                                        border: '1px solid #cbd5e1', borderRadius: 8, fontSize: '0.82rem', resize: 'vertical' }} />
                                <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 8, flexWrap: 'wrap' }}>
                                    <button className="btn-secondary" style={botao}
                                        onClick={() => navigator.clipboard?.writeText(g.texto)}>Copiar</button>
                                    {g.numero && (
                                        <button className="btn-primary" style={botao} disabled={ocupado}
                                            onClick={() => enviar([g])}>
                                            Enviar a este
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))}
                        {lote.length > 0 && (
                            <p style={{ fontSize: '0.78rem', color: '#475569', margin: '0 0 8px' }}>
                                Abre uma conversa por colaborador, com a mensagem já escrita. Falta
                                carregares em enviar em cada uma — o WhatsApp Web não deixa saltar esse passo.
                                Da primeira vez o browser pode pedir para autorizar as janelas.
                            </p>
                        )}
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                            {lote.some(g => g.numero) && (
                                <button className="btn-primary" disabled={ocupado} onClick={() => enviar(lote)}>
                                    📲 Enviar todas ({lote.filter(g => g.numero).length})
                                </button>
                            )}
                            <button className="btn-secondary" onClick={() => setLote(null)}>Fechar</button>
                        </div>
                    </div>
                </LiquidDialog>
            )}
        </>
    );
};

export default LoteMensagens;
